<template>
  <div style="max-width: 40vw">
    <div v-if="groupLayoutId">
      <div class="group-img-container">
        <div
          style="position: relative"
          v-for="(item, index) in message.getPhotoList"
          class="photo-container"
          :key="index">
          <PhotoImage
            v-if="!(index === message.getPhotoList.length - 1 && message.getPhotoList.length % 2 != 0)"
            class="pointer rounded"
            :class="isUndoOrDelete(item) && 'opacity-img'"
            fit="cover"
            style="width: 160px; height: 160px"
            :sources="photoSources([item.url, item.thumb], item.globalMes)"
            :cache-key="photoKey(item.globalMes)"
            :preview-src-list="getImageAndVideo()" />
          <div
            class="chat-photo-forward"
            @click.stop.prevent="forwardMessage(item)">
            <IconV2
              name="v2-share"
              color="#3484F0" />
          </div>
          <div
            v-if="!(index === message.getPhotoList.length - 1 && message.getPhotoList.length % 2 != 0) && isUndoOrDelete(item)"
            class="content-opacity">
            {{ item.globalMes.checkUndoMessage ? "Đã thu hồi" : "Đã xóa" }}
          </div>
        </div>
      </div>
      <div
        style="position: relative"
        class="photo-container">
        <PhotoImage
          v-if="message.getPhotoList.length % 2 != 0"
          class="pointer rounded mx-1"
          :class="isUndoOrDelete(lastPhoto) && 'opacity-img'"
          fit="cover"
          style="width: 326px; height: 326px"
          :sources="photoSources([lastPhoto.url, lastPhoto.thumb], lastPhoto.globalMes)"
          :cache-key="photoKey(lastPhoto.globalMes)"
          :preview-src-list="getImageAndVideo()" />
        <div
          class="chat-photo-forward"
          @click.stop.prevent="forwardMessage(message.getPhotoList[message.getPhotoList.length - 1])">
          <IconV2
            name="v2-share"
            color="#3484F0" />
        </div>
        <div
          v-if="message.getPhotoList.length % 2 != 0 && isUndoOrDelete(message.getPhotoList[message.getPhotoList.length - 1])"
          class="content-opacity">
          {{ message.getPhotoList[message.getPhotoList.length - 1].globalMes.checkUndoMessage ? "Đã thu hồi" : "Đã xóa" }}
        </div>
      </div>
    </div>

    <div v-else>
      <div
        v-if="messageRepied"
        class="rounded d-flex align-items-center">
        <PhotoImage
          class="rounded align-self-center"
          fit="cover"
          style="width: 33px; height: 33px"
          :sources="replySources"
          compact-error />

        <div class="ms-2">[Hình ảnh]</div>
      </div>
      <div v-else>
        <div
          class="rounded p-1 photo-container"
          style="margin-bottom: -0.25rem">
          <PhotoImage
            class="pointer rounded"
            fit="cover"
            style="width: 334px"
            :preview-src-list="getImageAndVideo()"
            :sources="singleSources"
            :cache-key="photoKey(message)"
            :compact-error="!!quote"
            v-bind:style="quote ? 'max-width: 40px;max-height: 40px' : 'max-height: 450px'" />
          <div
            class="chat-photo-forward"
            @click.stop.prevent="forwardMessage(message)">
            <IconV2
              name="v2-share"
              color="#3484F0" />
          </div>
        </div>
        <div
          v-if="title"
          class="mb-0 mt-1 mx-12 text-normal"
          style="white-space: pre-line">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON } from "../../lib/Common";
import PhotoImage from "../common/PhotoImage";
import { resolvedPhotoUrl } from "../../lib/photo-url-cache";

export default {
  name: "ChatPhoto",
  components: { PhotoImage },
  props: ["href", "title", "quote", "messageList", "message", "groupLayoutId", "messageRepied"],
  data() {
    return {
      load: false,
      imagelist: [],
    };
  },

  computed: {
    lastPhoto() {
      const list = (this.message && this.message.getPhotoList) || [];
      return list[list.length - 1] || {};
    },
    // Ảnh đơn: HD -> href (ảnh gốc) -> thumb. CDN Zalo có lúc trả 404 cho bản gốc/HD
    // trong khi bản thumb 480px vẫn sống, nên thumb là chốt chặn cuối.
    singleSources() {
      return this.photoSources([this.hdFromContent, this.hrefFromContent, this.thumbFromContent, this.href], this.message);
    },
    // Khung trả lời chỉ 33px nên thumb là đủ, lại nhẹ và sống lâu hơn -> để trước.
    replySources() {
      return this.photoSources([this.thumbFromContent, this.hdFromContent, this.hrefFromContent, this.href], this.message);
    },
    hdFromContent() {
      return this.readContent(c => JSON.parse(c.params).hd);
    },
    hrefFromContent() {
      return this.readContent(c => c.href);
    },
    thumbFromContent() {
      return this.readContent(c => c.thumb);
    },
  },
  methods: {
    photoKey(mes) {
      try {
        return String(mes.id.msgId);
      } catch (e) {
        return "";
      }
    },
    // Đọc 1 trường trong content đã parse; content có thể thiếu (nhánh quote chỉ truyền href).
    readContent(pick) {
      try {
        return pick(JSON.parse(this.message.content)) || "";
      } catch (e) {
        return "";
      }
    },
    // Mọi link đều qua getCloudUrl (đổi link hết hạn > 10 ngày từ replaceLink) + toDisplayableImageUrl (jxl -> jpg).
    photoSources(urls, mes) {
      return (urls || []).filter(u => typeof u === "string" && u).map(u => this.toDisplayableImageUrl(this.getCloudUrl(u, mes)));
    },
    toDisplayableImageUrl(url) {
      // JPEG XL (.jxl) isn't rendered natively in Chrome/Firefox. The Zalo CDN serves the
      // same asset under /jpg/...jpg, so swap when the URL points at the jxl variant.
      if (typeof url !== "string" || !url) return url;
      return url.replace(/\/jxl\//gi, "/jpg/").replace(/\.jxl(\?|#|$)/i, ".jpg$1");
    },
    findUrlHDIfExist(content) {
      if (typeof content !== "string" || !content) return "";
      let parsed;
      try {
        parsed = JSON.parse(content);
      } catch (ex) {
        return "";
      }
      try {
        const linkHD = JSON.parse(parsed.params).hd;
        if (linkHD !== null && linkHD !== undefined) {
          return linkHD;
        }
      } catch (ex) {
        // fall through to href
      }
      return parsed.href || "";
    },
    isUndoOrDelete(message) {
      return message.globalMes.checkUndoMessage || message.globalMes.checkDeleteMessage;
    },
    // getPhotoList() {
    //   let photos = [];
    //   let filter = this.messageList.filter(p => p.msgType == "chat.photo");
    //   filter.forEach(item => {
    //     this.getPhoto(photos, item);
    //   });
    //   return photos.sort((a, b) => b.id - a.id);
    // },
    // getPhoto(photos, item) {
    //   console.log(1);
    //   let params = JSON.parse(JSON.parse(item.content).params);
    //   if (params.is_group_layout) {
    //     if (params.group_layout_id == this.groupLayoutId) {
    //       photos.push({ id: params.id_in_group, url: this.getCloudUrl(this.findUrlHDIfExist(item.content), item) });
    //     }
    //   }
    // },
    getImageAndVideo() {
      if (this.messageList) {
        let data = this.messageList
          .filter((s) => s.msgType == COMMON.CHAT_PHOTO)
          // Ưu tiên link đã tải được thật (ảnh đang hiện trên khung chat), tránh mở lightbox trắng
          // khi bản HD đã bị CDN xóa.
          .map((s) => resolvedPhotoUrl(this.photoKey(s)) || this.toDisplayableImageUrl(this.getCloudUrl(this.findUrlHDIfExist(s.content), s)));
        return data;
      } else {
        return [];
      }
    },
    forwardMessage(message) {
      if (message.globalMes) {
        const messageClone = { ...message.globalMes };
        messageClone.groupLayoutId = "";

        const messageContentClone = JSON.parse(messageClone.content);
        const params = JSON.parse(messageContentClone.params);
        params.is_group_layout = false;
        const jsonParams = JSON.stringify(params);
        messageContentClone.params = jsonParams;
        const jsonMessageContent = JSON.stringify(messageContentClone);
        messageClone.content = jsonMessageContent;

        this.$bus.$emit("forwardMessage", messageClone);
      } else {
        this.$bus.$emit("forwardMessage", message);
      }
    },
  },

  created() {},
};
</script>

<style scoped lang="scss">
.group-img-container {
  margin: 0.25rem 0rem 0 0.25rem;
  display: grid;
  max-width: 10%;

  grid-template-columns: repeat(2, minmax(164px, 1fr));
}
.opacity-img {
  opacity: 0.4;
  z-index: 99;
}
.content-opacity {
  color: red;
  position: absolute;
  top: calc(50% - 16px);
  width: 100%;
  display: flex;
  justify-content: center;
}
.photo-container {
  position: relative;
}
.photo-container:hover {
  .chat-photo-forward {
    display: block;
  }
}
.chat-photo-forward {
  display: none;
  position: absolute;
  background-color: #f4f5f9;
  top: 0.75rem;
  right: 0.75rem;
  padding: 1px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
